// CAROUSEL WITH MULTIPLE ITEMS

(function ($) {
    $(document).ready(function () {
        childrenSlider();
        bookNowButton();
    });

    function childrenSlider() {
        var wraps = $('.post_preview.layout_carousel_cut');

        if (wraps.length > 0) {
            wraps.each(function () {
                var wrap = $(this);
                var slider = wrap.find('.children_section'),
                    slickSlide = slider.find('.item_wrap'),
                    image = slider.find('.thumb a'),
                    prevTitle = slider.find('.prev_title');
                var slidesCount = slider.children().length;
                // refers to the carousel counter
                var status = wrap.find('.pagingInfo');
                var pagerWrap = status.parent();
                var slidesToShow = is_phone ? 1 : 2,
                    hasCarousel = false;

                if (is_phone) {
                    if (slidesCount > 1) {
                        hasCarousel = true;
                    }
                } else {
                    if (slidesCount > 2) {
                        hasCarousel = true;
                    }
                }

                wrap.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                    var i = ((currentSlide) ? (currentSlide / slidesToShow) : 0) + 1;
                    status.text(i + '/' + Math.ceil(slick.slideCount / slidesToShow));
                    if (is_phone && slidesCount < 2) {
                        pagerWrap.css('display', 'none');
                    } else if ((is_tablet_portrait || is_desktop) && slidesCount < 3) {
                        pagerWrap.css('display', 'none');
                    }
                });

                slider.on('init', function () {
                    lazyLoadInstance.update();
                });

                if (hasCarousel) {
                    slider.slick({
                        autoplay: false,
                        infinite: true,
                        slidesToShow: slidesToShow,
                        slidesToScroll: slidesToShow,
                        arrows: true,
                        dots: true,
                        rows: 0,
                        prevArrow: accor_arrow_prev,
                        nextArrow: accor_arrow_next,
                        appendArrows: wrap.find('.pager_wrap'),
                        appendDots: wrap.find('.pager'),
                        centerMode: false,
                        rtl: $('html').attr('dir') == 'rtl',
                    });
                } else {
                    pagerWrap.css('display', 'none');
                }

                slickSlide.attr('tabindex', '-1');
                image.attr('tabindex', '-1');


                if (!slickSlide.hasClass('prev_title_tabbable')) {
                    prevTitle.attr('tabindex', '-1');
                }

                slider.on('afterChange', function () {
                    setTimeout(function () {
                        slickSlide.attr('tabindex', '-1');
                        image.attr('tabindex', '-1');
                        if (!slickSlide.hasClass('prev_title_tabbable')) {
                            prevTitle.attr('tabindex', '-1');
                        }
                    }, 5)
                })
            })
        }
    }

    function bookNowButton() {
        var btn = $('.post_preview.layout_carousel_cut .item_wrap .btns .book a');

        btn.click(function () {
            var hotelID = $(this).attr('data-hotel-id');
            var roomID = $(this).attr('data-hotel-room-id');
            if (hotelID) {
                dedgeBookingInstance.getProvider('accor').bookNow({hotelId: hotelID, roomID:roomID});
            }

        })
    }
}(jQuery));